$.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    if(win.width() > 767){
    	viewport.bottom = viewport.top + win.height() - 110;
    } else {
    	viewport.bottom = viewport.top + win.height() - 55;
    }

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight() ;

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

$(window).on('load', function()
{
	var wn = window.navigator,
		ua = wn.userAgent.toLowerCase(),
		av = wn.appVersion.toLowerCase(),
		up = window.location.protocol.toLowerCase();
	
	var	isMobile = (/iphone|ipod|kindle|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(ua)),
		isTablet = (/ipad|sch-i800|playbook|xoom|tablet|gt-p1000|gt-p7510|sgh-t849|nexus 7|shw-m180s|a100|dell streak|silk/i.test(ua)),
		isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	$.easing.quart         = function (x, t, b, c, d) { return -c * ((t=t/d-1)*t*t*t - 1) + b; };
	$.easing.easeOutCubic  = function (x, t, b, c, d) { t /= d; t--; return c*(t*t*t + 1) + b; };
	$.easing.easeInOutQuad = function (x, t, b, c, d) { t /= d/2; if (t < 1) return c/2*t*t + b; t--; return -c/2 * (t*(t-2) - 1) + b; };
	$.easing.easeInQuad    = function (x, t, b, c, d) { t /= d; return c*t*t + b; };
	$.easing.easeOutQuad   = function (x, t, b, c, d) { t /= d; return -c * t*(t-2) + b; };

	var $window = $(window);
	var $page = $('body').attr('id');
	var _ww,_wh, _ws;
	

	var navOp = false;
	$('#corner-bottom-left').on({ click:function($evt) { _setNav(); }});

	$('#nav-tel').on({ click:function($evt) { window.location.href = 'tel:00813-6278-9559'; }});
	
	
	$('a').click(function($evt) {
		var uri = $(this).attr('href');
		if($(this).attr('target') == '_blank'){
			window.open(uri);
		} else {
			if(navOp) { _setNav(); }
			$('aside#loader').css({'display':'block'}).animate({ 'opacity': 1 }, 500, 'easeOutQuad', function() { 
				window.location.href = uri;
			});
		}
	    $evt.preventDefault();
	});


  	var checkbottomleftcolor = false;
	function _setNav() {
		if(!navOp){
			$('nav').stop(true,false).animate({ 'left': 0 }, 800, 'quart');
			$('#corner-bottom-left-stat-scroll').stop(true,false).animate({ 'left': '38px' }, 500, 'quart');
			if($('#corner-bottom-left').hasClass('white')) { 
				$('#corner-bottom-left').removeClass('white'); 
				checkbottomleftcolor = true;
			}
			navOp = true;
		} else {
			if(_ww > 767){
				$('nav').stop(true,false).animate({ 'left': '-33.33333%' }, 800, 'quart');
			} else {
				$('nav').stop(true,false).animate({ 'left': '-100%' }, 800, 'quart');
			}
			$('#corner-bottom-left-stat-scroll').stop(true,false).animate({ 'left': '18px' }, 800, 'quart');
			if(checkbottomleftcolor){
				$('#corner-bottom-left').addClass('white'); 
				checkbottomleftcolor = false;
			}
			navOp = false;
			__setScroll();
		}
		 
	}



	$('#footer-scrolltop').on({ 
		click:function($evt) { 
			$('html, body').animate({scrollTop: 0}, 1200, 'easeInOutQuad');
			$evt.preventDefault();
		}
	});

	if($page === 'teaser')
	{
		if(isMobile){
            window.location.href = './top/index.html';
        }
        else 
        {
        	$('aside#loader').delay(100).animate({ 'opacity': 0 }, 1000, 'easeInOutQuad', function(){
	            $(this).css({'display':'none'}).removeClass('black');
	            $('aside#loader img').css({'opacity':0});
	        });

	        $('video').on({ 
	            click:function($evt) { 
	                $('aside#loader').css({'display':'block'}).animate({ 'opacity': 1 }, 1000, 'easeInOutQuad', function(){
	                	window.location.href = './top/index.html';
	                }); 
	            }
	        });

	        $('video')[0].currentTime = 0;
	        $('video')[0].play();
	        $('video')[0].addEventListener('ended', function(){ 
	            $('aside#loader').css({'display':'block'}).animate({ 'opacity': 1 }, 1000, 'easeInOutQuad', function(){
	            	window.location.href = './top/index.html';
	            });     
	        }, false);
        }
	}
	else 
	{
		if($page != 'main') {
			$('aside#loader').delay(400).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
				$(this).css({'display':'none'});
				$('aside#loader img').css({'opacity': 0});
			});
		}
	}

	//=======================

	if($page === 'main')
	{

		if(isMobile){
			var refername = ['about','rooms','cafe-bar','art-design','gallery','privacy'],
				referurl = document.referrer,
				refercache = false;
			for(var i=0; i<refername.length; i++){
				if(referurl.includes(refername[i])){
					refercache = true;
				} 
			}

			if(!refercache) { 
				$('aside#loader img').delay(100).animate({opacity: 1 }, 800, 'easeInOutQuad',function(){
					$(this).delay(800).animate({opacity: 0 }, 500, 'easeInOutQuad');
				});
				$('aside#loader').stop(true,true).delay(1800).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
					$(this).css({'display':'none'});
					$('aside#loader img').css({'opacity': 0});
				});
			}
			else 
			{
				$('aside#loader').delay(400).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
					$(this).css({'display':'none'});
					$('aside#loader img').css({'opacity': 0});
				});
			}
		}
		else 
		{
			$('aside#loader').delay(400).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
				$(this).css({'display':'none'});
				$('aside#loader img').css({'opacity': 0});
			});
		}

		var pil;
		var piw;
		var currentroom = 0;

		pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
		piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();

		$('#rooms-sp-l3 div#rooms-sp-l3-scroll').stop(true,false).animate({left: (((_ww  - piw)/2) - pil) }, 800, 'easeInOutQuad');

		var roomuri = ['double','twin','triple','king','universal','amenities'];
		var mainRoomSwiperSP = new Swiper('#rooms-sp-l2 .swiper-container', {
			speed: 1200,
			loop: false,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
		});  
		mainRoomSwiperSP.on('transitionStart', function () {  
			currentroom = mainRoomSwiperSP.realIndex;
			$('#rooms-sp-l2 a').attr('href', '../rooms/index.html#'+roomuri[currentroom]);
			$('#rooms-sp-l3 div ul li').removeClass('active');
			$('#rooms-sp-l3 div ul li').eq(currentroom).addClass('active');
			pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
			piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();

			$('#rooms-sp-l3 div#rooms-sp-l3-scroll').stop(true,false).animate({left: (((_ww  - piw)/2) - pil) }, 800, 'easeInOutQuad');
		});

		$('#rooms-sp-l3 div ul li').on({ 
			click:function($evt) { 
				mainRoomSwiperSP.slideTo($(this).index(),1200,false );
				currentroom = $(this).index();
				$('#rooms-sp-l2 a').attr('href', '../rooms/index.html#'+roomuri[currentroom]);
				$('#rooms-sp-l3 div ul li').removeClass('active');
				$('#rooms-sp-l3 div ul li').eq(currentroom).addClass('active');
				pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
				piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();

				$('#rooms-sp-l3 div#rooms-sp-l3-scroll').stop(true,false).animate({left: (((_ww  - piw)/2) - pil) }, 800, 'easeInOutQuad');
				$evt.preventDefault();
			}
		});

		$('.scrolltop').on({ 
			click:function($evt) { 
				if(_ww > 767) {
					$('html, body').animate({scrollTop: $('section#about-rooms-pc').offset().top}, 800, 'easeInOutQuad');
				} else {
					$('html, body').animate({scrollTop: $('section#about-sp').offset().top}, 800, 'easeInOutQuad');
				}
				$evt.preventDefault();
			}
		});
		
		var mainRoomSwiperPC = new Swiper('#row-l3-c2-pc-slider .swiper-container', {
			speed: 1200,
			loop: false,
			direction: 'vertical',
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: { delay: 5000 },
		});
		mainRoomSwiperPC.on('transitionStart', function () {  
			setSlideshowRoomPC(mainRoomSwiperPC.realIndex,'auto');
		});

		$('#row-l1-l2-c1-pc ul li').on({ 
			click:function($evt) { 
				setSlideshowRoomPC($(this).index(),'btn');
				$evt.preventDefault();
			}
		});

		function setSlideshowRoomPC($id,$from){
			if($from === 'btn'){
				mainRoomSwiperPC.slideTo($id,1200,false);
				$('#row-l1-l2-c1-pc ul li').removeClass('active');
				$('#row-l1-l2-c1-pc ul li').eq($id).addClass('active');	
				$('a#row-l3-c2-pc-more').attr('href', '../rooms/index.html#'+$('#row-l1-l2-c1-pc ul li').eq($id).data('uri'));
			} else {
				$('#row-l1-l2-c1-pc ul li').removeClass('active');
				$('#row-l1-l2-c1-pc ul li').eq($id).addClass('active');	
				$('a#row-l3-c2-pc-more').attr('href', '../rooms/index.html#'+$('#row-l1-l2-c1-pc ul li').eq($id).data('uri'));
			}
		}

		var token, 
		username,
		userid,
		clientid,
	    num_photos = 12;

    /*	token = '2291770268.3123fa1.7594b39aabab4c74a7e3b10ee4b9fb18';
    	userid = '2291770268'; 
    	clientid = '3123fa121b1d47ec9bc61a5ab6a47415';*/

    	token = '9627749552.1677ed0.48a659732a2c46468e0f02295907c93c';
    	userid = '9627749552';
    	clientid = '6fc945c0b21145b0975c8a2218bfb39e'
		username = 'bspkhotel';
		
	    var countInsta = 0;

	    $.ajax({
			url: 'https://api.instagram.com/v1/users/'+userid+'/media/recent/',
			dataType: 'jsonp',
			type: 'GET',
			data: {access_token: token, q: username, count: num_photos, client_id: clientid},
			success: function(data)
			{
				for(var x in data.data){
					if(data.data[x].type != 'video'){
						$('#insta-pc').append('<a href="'+data.data[x].link+'" target="_blank"><div class="insta-pc-view" style="background-image:url('+data.data[x].images.standard_resolution.url+');"></div></a>');
						countInsta++;
						if(countInsta < 9) {
							$('#insta-sp').append('<a href="'+data.data[x].link+'" target="_blank"><div class="insta-sp-view" style="background-image:url('+data.data[x].images.standard_resolution.url+');"></div></a>');
						}
					}
				}
				$('.insta-pc-view').css({'height':$('.insta-pc-view').width()});
				$('.insta-sp-view').css({'height':$('.insta-sp-view').width()});
			},
			error: function(data){ console.log('error: '+data); }
		});
	} 

	//======================================

	function _getRoomHash()
	{
		if(_ww > 767)
		{ 
			switch(document.location.hash)
			{
				case '#double':
					$('html, body').delay(500).animate({scrollTop: $('#l3-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#twin':
					$('html, body').delay(500).animate({scrollTop: $('#l4-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#triple':
					$('html, body').delay(500).animate({scrollTop: $('#l5-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#king':
					$('html, body').delay(500).animate({scrollTop: $('#l6-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#universal':
					$('html, body').delay(500).animate({scrollTop: $('#l7-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#amenities':
					$('html, body').delay(500).animate({scrollTop: $('#l8-c1').offset().top}, 800, 'easeInOutQuad');
				break;
			}
		}
		else 
		{
			switch(document.location.hash)
			{
				case '#double':
					$('html, body').animate({scrollTop: $('#l3').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#twin':
					$('html, body').animate({scrollTop: $('#l4').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#triple':
					$('html, body').animate({scrollTop: $('#l5').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#king':
					$('html, body').animate({scrollTop: $('#l6').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#universal':
					$('html, body').animate({scrollTop: $('#l7').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#amenities':
					$('html, body').animate({scrollTop: $('#l8').offset().top}, 800, 'easeInOutQuad');
				break;
			}
		}
	}

	//=========================

	if($page === 'rooms')
	{
		$('#l2-c2-c3 ul li').on({ 
			click:function($evt) { 
				switch($(this).data('uri'))
				{
					case 'double':
						$('html, body').animate({scrollTop: $('#l3-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'twin':
						$('html, body').animate({scrollTop: $('#l4-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'triple':
						$('html, body').animate({scrollTop: $('#l5-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'king':
						$('html, body').animate({scrollTop: $('#l6-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'universal':
						$('html, body').animate({scrollTop: $('#l7-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'amenities':
						$('html, body').animate({scrollTop: $('#l8-c1').offset().top}, 800, 'easeInOutQuad');
					break;
				}
				$evt.preventDefault();
			}
		});

		$('#l2 ul li').on({ 
			click:function($evt) { 
				switch($(this).data('uri'))
				{
					case 'double':
						$('html, body').animate({scrollTop: $('#l3').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'twin':
						$('html, body').animate({scrollTop: $('#l4').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'triple':
						$('html, body').animate({scrollTop: $('#l5').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'king':
						$('html, body').animate({scrollTop: $('#l6').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'universal':
						$('html, body').animate({scrollTop: $('#l7').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'amenities':
						$('html, body').animate({scrollTop: $('#l8').offset().top}, 800, 'easeInOutQuad');
					break;
				}
				$evt.preventDefault();
			}
		});

		var doubleSwiperPC = new Swiper('#l3-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		}),
		twinSwiperPC = new Swiper('#l4-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			disableOnInteraction: true,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		}),
		tripleSwiperPC = new Swiper('#l5-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		}),
		kingSwiperPC = new Swiper('#l6-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		});  

		var doubleSwiperSP = new Swiper('#l3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		twinSwiperSP = new Swiper('#l4 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		tripleSwiperSP = new Swiper('#l5 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		kingSwiperSP = new Swiper('#l6 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		});
	}

	//=========================

	if($page === 'art')
	{
		$('#play-pc, #play-sp').on({
	    	click:function($evt) { 
	    		setModalVideo(true,'G-wUYXuheho');
	    		$evt.preventDefault();
	    	}
		},'');

		$('#modal-video-close, #modal-video-bg').on({
	    	click:function($evt) { 
	    		setModalVideo(false,'G-wUYXuheho');
	    		$evt.preventDefault();
	    	}
		},'');

		function setModalVideo($val, $uri){
			if($val){
				$('#modal-video #modal-video-close').stop().css({'opacity':0}).delay(800).animate({ opacity: 1}, 800, 'quart');
				$('#modal-video').stop().css({'display':'block','opacity':0}).animate({ opacity: 1}, 800, 'quart', function() { 
					var uri = 'https://www.youtube.com/embed/'+$uri+'?autoplay=1&rel=0&showinfo=0';
					$('#modal-video iframe').attr('src',uri).css({'display':'block'});
				});	
			}else{
				$('#modal-video').animate({ opacity: 0}, 800, 'quart', function() {
					$('#modal-video iframe').attr('src','').css({'display':'none'});
					$(this).css({'display':'none'});
				});
			}
	   };

		var graphSwiperSP = new Swiper('#l4 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		displaySwiperSP = new Swiper('#l5 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		});
	}

	function __setPosition()
	{
		_ww = $window.width();
		_wh = $window.height();

		if($page === 'main')
		{
			if(_ww > 767)
			{ 
				$('#top-l').css({'height':'100vh'});	
				$('.insta-pc-view').css({'height':$('.insta-pc-view').width()});
				
				$('#row-l1-c1-c2-pc').css({'height': ($('#row-l1-c1-c2-pc').width() / 2)});
				$('#row-l1-l2-c3-pc').css({'height': ($('#row-l1-l2-c3-pc').width() * 2) + 10});
				$('#row-l1-l2-c1-pc').css({'top': $('#row-l1-c1-c2-pc').position().top + $('#row-l1-c1-c2-pc').height(), 'height': ($('#row-l1-l2-c1-pc ').width() * 2)});
				$('#row-l2-c2-pc').css({'top': $('#row-l1-c1-c2-pc').position().top + $('#row-l1-c1-c2-pc').height(), 'height': $('#row-l2-c2-pc').width()});
				$('#row-l3-c2-pc').css({'top': $('#row-l2-c2-pc').position().top + $('#row-l2-c2-pc').height(), 'height': $('#row-l3-c2-pc').width()});
				$('#row-l3-c3-pc').css({'top': $('#row-l2-c2-pc').position().top + $('#row-l2-c2-pc').height(), 'height': $('#row-l3-c3-pc').width()});
				$('#about-rooms-pc').css({'height': ($('#row-l3-c3-pc').position().top + $('#row-l3-c3-pc').height())});

				$('#cafe-pc-col1').css({'height': $('#cafe-pc-col1').width()});
				$('#cafe-pc-col2').css({'height': $('#cafe-pc-col1').width()});
				$('#cafe-pc').css({'height': $('#cafe-pc-col1').height()});

				$('#art-pc-col1').css({'height': $('#art-pc-col1').width()});
				$('#art-pc-col2').css({'height': $('#art-pc-col1').width()});
				$('#art-pc-col3').css({'height': $('#art-pc-col1').width()});
				$('#art-pc').css({'height': $('#art-pc-col1').height()});

				$('#lobby-pc-col1').css({'height': $('#lobby-pc-col1').width()});
				$('#lobby-pc-col2').css({'height': $('#lobby-pc-col1').width()});
				$('#lobby-pc').css({'height': $('#lobby-pc-col1').height()});

				$('#gallery-pc-col1').css({'height': $('#gallery-pc-col1').width()});
				$('#gallery-pc-col2').css({'height': $('#gallery-pc-col1').width()});
				$('#gallery-pc-col3').css({'height': $('#gallery-pc-col1').width()});
				$('#gallery-pc').css({'height': $('#gallery-pc-col1').height()});

				$('#connect-pc-col1').css({'height': $('#connect-pc-col1').width()});
				$('#connect-pc-col2').css({'height': $('#connect-pc-col1').width()});
				$('.insta-view').css({'height':$('.insta-view').width()});
				$('#connect-pc').css({'height': $('#connect-pc-col1').height()});

				$('#place-pc, #place-pc-col2, #place-pc-col3').css({'height':'auto'});
				$('#place-pc-col1').css({'height': $('#place-pc-col2').height() + 60});
				$('#place-pc-col3').css({'height': $('#place-pc-col1').height() });
			//	$('#place-pc-col2').css({'height': $('#place-pc-col2').height() });
				
				$('#place-pc').css({'height': $('#place-pc-col1').height() });
				
				$('#contact-pc-col1').css({'height': ($('#contact-pc-col1').width())});
				$('#contact-pc-col2').css({'height': ($('#contact-pc-col1').width())});
				$('#contact-pc').css({'height': $('#contact-pc-col1').height()});

				$('footer').css({'position':'absolute','top': ($('#contact-pc-col1').height() + $('#contact-pc').position().top)});

				mainRoomSwiperPC.update();
			} 
			else 
			{

				$('#top-l').css({'height': $('section#top').height() - $('#top-r').height() - 120});

				$('.insta-sp-view').css({'height':$('.insta-sp-view').width()});
				$('#about-sp-l1').css({'height': ($('#about-sp-l1').width() / 2)});
				$('#about-sp-l2').css({'height': ($('#about-sp-l2').width() / 2)});
				$('#rooms-sp-l2').css({'height': ($('#rooms-sp-l2').width())});
				$('#cafe-sp-l2').css({'height': ($('#cafe-sp-l2').width() / 2)});
				$('#art-sp-l2').css({'height': ($('#art-sp-l2').width() / 2)});
				$('#gallery-sp-l2').css({'height': $('#gallery-sp-l2').width()});
				$('#insta-sp').css({'height': $('#insta-sp').width()});
				$('footer').css({'top':'auto','position':'relative'});

				pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
				piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();
				$('#rooms-sp-l3 div#rooms-sp-l3-scroll').css({left: (((_ww  - piw)/2) - pil) });
			}
			
		} 

		//========================

		if($page === 'about')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l2-c1, #l2-c2, #l2-c3').css({'top': $('#l1-c1').height()});
				$('#l2-c1').css({'height': $('#l2-c2').height()});
				$('#l2-c3').css({'height': $('#l2-c2').height()});
				
				if($('#l2-c2').height() + $('#l2-c2').position().top + 130 > _wh){
					$('footer').css({'position':'absolute','top': ($('#l2-c2').height() + $('#l2-c2').position().top)});
				} else {
					$('footer').css({'position':'absolute','top':'auto','bottom':0});
				}
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'rooms')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l2-c1, #l2-c2-c3').css({'top': $('#l1-c1').height()});
				$('#l2-c2-c3').css({'height': $('#l2-c1').height()});
				$('#l3-c1').css({'top': $('#l2-c1').height() + $('#l2-c1').position().top });
				$('#l3-c2-c3').css({'top': $('#l3-c1').position().top, 'height': $('#l3-c1').height() });
				$('#l4-c1').css({'top': $('#l3-c1').height() + $('#l3-c1').position().top });
				$('#l4-c2-c3').css({'top': $('#l4-c1').position().top, 'height': $('#l4-c1').height() });
				$('#l5-c1').css({'top': $('#l4-c1').height() + $('#l4-c1').position().top });
				$('#l5-c2-c3').css({'top': $('#l5-c1').position().top, 'height': $('#l5-c1').height() });
				$('#l6-c1').css({'top': $('#l5-c1').height() + $('#l5-c1').position().top });
				$('#l6-c2-c3').css({'top': $('#l6-c1').position().top, 'height': $('#l6-c1').height() });
				$('#l7-c1').css({'top': $('#l6-c1').height() + $('#l6-c1').position().top });
				$('#l7-c2-c3').css({'top': $('#l7-c1').position().top, 'height': $('#l7-c1').height() });
				$('#l8-c1').css({'top': $('#l7-c1').height() + $('#l7-c1').position().top + 40});
				$('#l8-c2-c3').css({'top': $('#l8-c1').position().top});
				$('#l8-c1').css({'height': $('#l8-c2-c3').height() });
				$('footer').css({'position':'absolute','top': ($('#l8-c1').height() + $('#l8-c1').position().top )});
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto'});
			}
		}

		//========================

		if($page === 'cafe')
		{
			if(_ww > 767)
			{
				$('#l1-l2-c2-c3').css({'height': $('#l1-c1').height()});
			//	$('#l3-c1-c2-c3').css({'top': $('#l1-c1').position().top + $('#l1-c1').height()});
			//	$('footer').css({'position':'absolute','top': ($('#l3-c1-c2-c3').height() + $('#l3-c1-c2-c3').position().top + 90)});
				$('footer').css({'position':'absolute','top': ($('#l1-l2-c2-c3').height() + $('#l1-l2-c2-c3').position().top)});
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'art')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l1-c2-c3 #l1-c2-c3-2').css({'height': $('#l1-c2-c3 #l1-c2-c3-2-r').height() });
				$('#l1-c2-c3 #l1-c2-c3-1').css({'height': ($('#l1-c2-c3').height() - $('#l1-c2-c3 #l1-c2-c3-2').height()) });

				$('#l1-c2-c3-2-l').css({'height': $('#l1-c2-c3 #l1-c2-c3-2').height()});

				$('#l2-c1').css({'top': $('#l1-c1').height() + $('#l1-c1').position().top });
				$('#l2-c2-c3').css({'top': $('#l2-c1').position().top, 'height': $('#l2-c1').height() });

				$('#l3-c3').css({'height': $('#l3-c3').width() });
				$('#l3-c1-c2').css({'top': ($('#l2-c2-c3').position().top + $('#l2-c2-c3').height()), 'height': $('#l3-c3').height() });
				$('#l3-c3').css({'top': $('#l3-c1-c2').position().top });

				$('#l4-c1-c2').css({'top': ($('#l3-c3').position().top + $('#l3-c3').height()) });
				$('#l4-c3').css({'top': $('#l4-c1-c2').position().top });
				$('#l4-c1-c2').css({'height': ($('#l4-c3').height()) });

				$('footer').css({'position':'absolute','top': ($('#l4-c3').height() + $('#l4-c3').position().top)});
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'gallery')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l2-c1-c2').css({'top': $('#l1-c1').height(), 'height': ($('#l2-c1-c2').width() / 2) });
				$('#l2-l3-c3').css({'top': $('#l1-c1').height(), 'height': ($('#l2-c1-c2').height() * 2) });
				$('#l3-c1').css({'top': ($('#l2-c1-c2').height() + $('#l2-c1-c2').position().top), 'height': $('#l3-c1').width() });
				$('#l3-c2').css({'top': $('#l3-c1').position().top, 'height': $('#l3-c1').width() });
				$('#l4-l5-c1').css({'top': ($('#l3-c1').height() + $('#l3-c1').position().top), 'height': ($('#l4-l5-c1').width() * 2)});
				$('#l4-c1-c2').css({'top': $('#l4-l5-c1').position().top, 'height': $('#l4-l5-c1').width() });
				$('#l5-c1-c2').css({'top': $('#l4-l5-c1').position().top + $('#l4-l5-c1').width(), 'height': $('#l4-l5-c1').width() });
				$('#l6-c1-c2').css({'top': ($('#l4-l5-c1').height() + $('#l4-l5-c1').position().top), 'height': ($('#l6-c1-c2').width() / 2)});
				$('#l6-c3').css({'top': $('#l6-c1-c2').position().top, 'height': ($('#l6-c3').width())});
				$('#l7-c1-c2-c3').css({'top': ($('#l6-c3').height() + $('#l6-c3').position().top), 'height': ($('#l6-c3').width())});
				$('#l8-c1').css({'top': ($('#l7-c1-c2-c3').height() + $('#l7-c1-c2-c3').position().top), 'height': ($('#l6-c3').width() * 2)});
				$('#l8-c2-1').css({'top': $('#l8-c1').position().top, 'height': ($('#l6-c3').width())});
				$('#l8-c2-2').css({'top': ($('#l8-c2-1').position().top + $('#l8-c2-1').height()), 'height': ($('#l6-c3').width())});
				$('#l9-c1-c2').css({'top': ($('#l8-c1').position().top + $('#l8-c1').height()), 'height': ($('#l9-c1-c2').width() / 2)});
				$('#l10-c1-c2').css({'top': ($('#l9-c1-c2').position().top + $('#l9-c1-c2').height()), 'height': ($('#l9-c1-c2').width() / 2)});
				$('#l9-l10-c3').css({'top': $('#l9-c1-c2').position().top, 'height': ($('#l9-c1-c2').height() + $('#l10-c1-c2').height())});
				$('#l11-c1').css({'top': ($('#l9-l10-c3').position().top + $('#l9-l10-c3').height()), 'height': ($('#l11-c1').width() + 200)});
				$('#l11-c2').css({'top': $('#l11-c1').position().top, 'height': ($('#l11-c1').width() + 200)});
				$('#l11-c3').css({'top': $('#l11-c1').position().top, 'height': ($('#l11-c1').width() + 200)});
				$('#l12-c1').css({'top': ($('#l11-c1').position().top + $('#l11-c1').height()), 'height': $('#l12-c1').width() });
				$('#l12-c2-c3').css({'top': $('#l12-c1').position().top, 'height': $('#l12-c1').width() });
				$('footer').css({'position':'absolute','top': ($('#l12-c1').height() + $('#l12-c1').position().top)});
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'privacy')
		{
			if(_ww > 767)
			{
				$('footer').css({'position':'absolute','top': ($('#l1-c2-c3').height() + $('#l1-c2-c3').position().top)});
			}
			else
			{
				$('footer').css({'position':'relative','top':'auto','bottom':'auto','margin-top':'-60px' });
			}
		}

	}

	$window.resize(function() { __setPosition(); });	
	__setPosition();

	if($page === 'rooms' && document.location.hash != ''){ _getRoomHash(); }


	function __setScroll()
	{
		_ws = $(window).scrollTop();

		if(navOp) { _setNav(); }

		if($page === 'main')
		{
			if(_ww > 767)
			{
				if((_ws + 65) > $('#about-rooms-pc').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) > $('#art-pc').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 65) > $('#gallery-pc').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) > $('#connect-pc').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 65) > $('#contact-pc').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) < $('#about-rooms-pc').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }

				if((_ws + 65) > $('#cafe-pc').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 65) > $('#connect-pc').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 65) > $('#place-pc').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 65) < $('#cafe-pc').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }

				if($('#top').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#about-rooms-pc').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#cafe-pc').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#art-pc').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#gallery-pc').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#place-pc').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#contact-pc').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('footer').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#top').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#about-rooms-pc').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#cafe-pc').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#art-pc').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#lobby-pc').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#gallery-pc').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#connect-pc').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#place-pc').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#contact-pc').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('footer').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
			}
			else 
			{
				if((_ws + 30) < $('#about-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#about-sp').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#rooms-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#cafe-sp').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#art-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#gallery-sp').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#connect-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#book-sp').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#map-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#contact-sp').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }

				if((_ws + 30) < $('#about-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#about-sp').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#rooms-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#cafe-sp').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#art-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#gallery-sp').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#connect-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#book-sp').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#map-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#contact-sp').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }

				if($('#top').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#about-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#rooms-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#cafe-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#art-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#gallery-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#connect-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#book-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#map-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#contact-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('footer').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#top').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#about-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#rooms-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#cafe-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#art-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#gallery-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#connect-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#book-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#map-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#contact-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('footer').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
			}
		}

		//===============================

		if($page === 'rooms')
		{
			if(_ww > 767)
			{
				if((_ws + 65) < $('#l3-c2-c3').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) > $('#l2-c2-c3').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 65) > $('#l3-c2-c3').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) > $('#l8-c2-c3').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }

				if((_ws + 65) < $('#l3-c1').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 65) > $('#l3-c1').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 65) > $('#l4-c1').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 65) > $('#l5-c1').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 65) > $('#l6-c1').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 65) > $('#l7-c1').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 65) > $('#l8-c1').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }

				if($('#l2-c1').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l3-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l4-c1').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l5-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l6-c1').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l7-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l8-c1').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#l1-c2-c3').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l2-c2-c3').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#l3-c2-c3').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l7-c2-c3').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l8-c2-c3').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }

			}
			else 
			{
				if((_ws + 30) < $('#l2').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#l2').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#l3').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#l4 .block-room-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#l5').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#l6 .block-room-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#l7 .block-room-sp').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#l8').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }

				if((_ws + 30) < $('#l2').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#l2').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#l3').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#l4 .block-room-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#l5').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#l6 .block-room-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#l7 .block-room-sp').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#l8').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }

				if($('#l2').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l3').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l4 .block-room-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l5').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l6 .block-room-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l7 .block-room-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l8').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#l2').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#l3').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l4 .block-room-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#l5').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l6 .block-room-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#l7 .block-room-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l8').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }

			}
		}
		
		//===============================

		if($page === 'art')
		{
			if(_ww > 767)
			{
				if((_ws + 65) < $('#l1-c2-c3-2').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) > $('#l1-c2-c3-2').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 65) > $('#l2-c2-c3').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 65) > $('#l4-c3').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }

				if((_ws + 65) < $('#l2-c1').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 65) > $('#l2-c1').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }

				if($('#l1-c1').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l2-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l3-c1-c2').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#l1-c2-c3-1').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l1-c2-c3-2').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
			}
			else 
			{
				if((_ws + 30) < $('#l2').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#l2').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#l4 .swiper-container').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }
				if((_ws + 30) > $('#l5 .block-art-sp').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }

				if((_ws + 30) < $('#l2').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#l2').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#l4 .swiper-container').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }
				if((_ws + 30) > $('#l5 .block-art-sp').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }

				if($('#l4 .swiper-container').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l4 .block-art-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l5 .block-art-sp').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#l4 .swiper-container').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('#l4 .block-art-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l5 .block-art-sp').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }

			}
		}

		//===============================

		if($page === 'gallery')
		{
			if(_ww > 767)
			{
				if((_ws + 65) < $('#l2-c1-c2').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 65) > $('#l2-c1-c2').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }

				if($('#l2-c1-c2').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l12-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('footer').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l12-c1').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l11-c3').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l12-c2-c3').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
				if($('footer').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
			}
			else 
			{
				if((_ws + 30) < $('#l2').offset().top && $('#corner-top-right').hasClass('white')) { $('#corner-top-right').removeClass('white'); }
				if((_ws + 30) > $('#l2').offset().top && !$('#corner-top-right').hasClass('white')) { $('#corner-top-right').addClass('white'); }

				if((_ws + 30) < $('#l2').offset().top && $('#corner-top-left').hasClass('white')) { $('#corner-top-left').removeClass('white'); }
				if((_ws + 30) > $('#l2').offset().top && !$('#corner-top-left').hasClass('white')) { $('#corner-top-left').addClass('white'); }

				if($('#l2').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l4').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l5').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }
				if($('#l6').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l15').isOnScreen() && !$('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').addClass('white'); }
				if($('#l16').isOnScreen() && $('#corner-bottom-left').hasClass('white')) { $('#corner-bottom-left').removeClass('white'); }

				if($('#l2').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l15').isOnScreen() && !$('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').addClass('white'); }
				if($('#l16').isOnScreen() && $('#corner-bottom-right').hasClass('white')) { $('#corner-bottom-right').removeClass('white'); }
			}
		}


	}
	$(window).on('resize scroll', function() { __setScroll(); });
	__setScroll();


			

	
});

